export default {
  HISTORIES: (state) => state.histories,
};
